<template>
  <img :src="`/svg/${icon}.svg`" :alt="icon" :class="svgClass" :style="svgStyle" />
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Icon',
  inheritAttrs: false,
  props: {
    // file name
    icon: {
      type: String,
      required: true,
    },
    // svg'ye gonderilecek class="" değeri
    svgClass: {
      type: String,
      required: false,
    },
    // svg'ye gonderilecek style="" değeri
    svgStyle: {
      type: String,
      required: false,
    },
  },
});
</script>
